export { default } from "./ClaimProcessing.gql";
